const {
  STORYBLOK_TOKENS: STORYBLOK_TOKENS_INT
} = require("../../utils/fdr/storyblok");
const {
  APPTENTIVE_TOKENS: APPTENTIVE_TOKENS_INT
} = require("../../utils/fdr/apptentive");

module.exports = {
  domain: {
    desktop: "racing.qa.fndl.dev",
    mobile: "racing.qa.fndl.dev",
    talentPicks: "racing.qa.fndl.dev/talent-picks/",
    accountWallet: "account.racing.qa.fndl.dev",
    equibase: "equibase-store.qa.fndl.dev"
  },
  service_host: "racing.qa.fndl.dev",
  externalDomain: {
    FDTermsConditions: "https://www.qa.fndl.dev/terms",
    FDPolicy: "https://www.qa.fndl.dev/privacy",
    FDRLoginBridge: "https://www.qa.fndl.dev/sso-auth/fdracing",
    FDRSignup:
      "https://www.qa.fndl.dev/join?next=%2Fsso-auth%2Ffdracing%3Fredirect_uri%3D"
  },
  externalServices: {
    fanduel: "https://api.qa.fndl.dev",
    cpp: "https://promos-api.racing.fanduel.qa.fndl.dev"
  },
  clientId: "a301e728606047a5b6522727d495b3ed",
  brazeId: "d1c732dc-ad0d-49a5-acb7-d360cd0fee38",
  storyblokToken: STORYBLOK_TOKENS_INT.QA,
  storyblokVersion: "draft",
  appTentiveIos: APPTENTIVE_TOKENS_INT.IOS.QA,
  appTentiveAndroid: APPTENTIVE_TOKENS_INT.ANDROID.QA,
  appTentiveWeb: APPTENTIVE_TOKENS_INT.WEB.QA
};
